import { render, staticRenderFns } from "./Error500Page.vue?vue&type=template&id=5ed6d7b8&"
import script from "./Error500Page.vue?vue&type=script&lang=ts&"
export * from "./Error500Page.vue?vue&type=script&lang=ts&"
import style0 from "./Error500Page.vue?vue&type=style&index=0&id=5ed6d7b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports